import { baseUrl } from '../constants/backendUrls';
import axios from 'axios';

let instance = null;

const getInstance = () => {

    if (instance) return instance;

    let userData = JSON.parse(localStorage.getItem("userData"));
    let token;

    if (userData) {
        token = userData.token;
    }
    
    instance = axios.create({
        baseURL: baseUrl,
    });

    instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    instance.defaults.headers.post['Content-Type'] = 'application/json';

    instance.interceptors.request.use(request => {
        return request;
    },
        error => {
            console.log(error);
            return Promise.reject(error);
        });

    instance.interceptors.response.use(response => {
        return response;
    },
        error => {
            console.log(error.response);
            return Promise.reject(error);
        });
    return instance;
}

export default getInstance;